var React = require('react');

function Tel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.4161 10.5489L6.94619 12.722L9.08667 19.9694C9.22363 20.4336 9.76275 20.6052 10.1206 20.2971L13.2032 17.6514C13.5263 17.3742 13.9865 17.3604 14.3242 17.6185L19.884 21.8683C20.2668 22.1612 20.8092 21.9404 20.9052 21.4534L24.978 0.82706C25.0828 0.295085 24.5864 -0.148705 24.1052 0.047206L1.40962 9.26505C0.849538 9.49247 0.854418 10.3273 1.4161 10.5489ZM8.74171 11.5652L19.5496 4.55695C19.7438 4.43137 19.9436 4.70789 19.7768 4.87078L10.8572 13.6C10.5437 13.9073 10.3415 14.3185 10.2842 14.7648L9.98035 17.1354C9.94011 17.452 9.51779 17.4834 9.43483 17.1771L8.26627 12.8541C8.13243 12.3611 8.32747 11.8344 8.74171 11.5652Z","fill":"#0EE9C4"}));
}

Tel.defaultProps = {"width":"25","height":"22","viewBox":"0 0 25 22","fill":"none"};

module.exports = Tel;

Tel.default = Tel;
